import { render, staticRenderFns } from "./ApproveVideoSaleModal.vue?vue&type=template&id=2ecf618a&"
import script from "./ApproveVideoSaleModal.vue?vue&type=script&lang=js&"
export * from "./ApproveVideoSaleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports